import BaseSchema from "./base";
import dayjs from "dayjs";

class Project extends BaseSchema {
  static primaryKey = "uuid";
  static tableName = "projects";
  static fields = [
    "uuid",
    // INFO - B.L - 02/03/2023 - NOT THE REAL ID only used for sampleFlask name
    "id",
    "readableId",
    "clientUuid",
    "caseUuid",
    "contributorUuid",
    "mission",
    "createdAt",
    "updatedAt",
    "chronorapso",
    "originId",
    "agencyCode",
    "agencyName",
    "workDescription",
    "projectName",
    "postcode",
    "city",
    "address",
    "managerUuid",
    "managerEmail",
    "managerSocotecCode",
    "estimatedDuration",
    "opeStartDate",
    "phase",
    "description",
    "isArchived",
    "vleText",
    "controlTypes",
    "cofracType",
    "controlObjective",
    "controlStart",
    "controlEnd",
    "isUpdatedByAtmo",
    "measurementPlanValidationDate",
    // INFO - B.L - 28/08/2022 - Front specific fields
    "listerUpdatedAt",
    "isLoaded",
    "clientName",
    "vleComments",
    "complementaryInformation",
    "drealContactName",
    "drealContactFirstName",
    "clientContactCompany",
    "clientContactRole",
    "clientContactFirstName",
    "clientContactLastName",
    "clientContactAddress",
    "clientContactPostcode",
    "clientContactCity",
    "clientContactEmail",
    "clientContactTelephone",
    "clientContactMobile",
    "numS3ic",
    "unannouncedComments",
    "contractNumber",
    "installationCount",
  ];

  async getManyToOne(value) {
    if (value.reversedKey == "contributors") {
      return await this.db["contributors"]
        .filter((c) => {
          return c.companyProjectRole?.projectId === this.uuid;
        })
        .toArray();
    }
    return super.getManyToOne(value);
  }

  static relatedFields = {
    case: { field: "caseUuid", dataName: "case", tableName: "cases" },
    client: { field: "clientUuid", dataName: "client", tableName: "clients" },
    documents: {
      m2m: true,
      reversedKey: "relatedObjects",
      tableName: "documents",
    },
    contributors: {
      many: true,
      reversedKey: "contributors",
      tableName: "companyProjectRoles",
    },
    installations: {
      many: true,
      reversedKey: "project",
      tableName: "installations",
    },
    recordBooks: {
      many: true,
      reversedKey: "project",
      tableName: "recordBooks",
    },
  };

  static dateFields = [
    "createdAt",
    "updatedAt",
    "controlStart",
    "controlEnd",
    "measurementPlanValidationDate",
  ];

  static dateTimeFields = ["measurementPlanValidationDate"];

  static async formatListerData(data) {
    const extractedData = {
      uuid: data.projectUuid,
      projectName: data.rapsoProjectName || data.projectName,
      chronorapso: data.projectChronorapso,
      updatedAt: dayjs(data.projectUpdatedAt).toDate(),
      listerUpdatedAt: dayjs(data.projectUpdatedAt).toDate(),
      isArchived: data.projectIsArchived,
      agencyCode: data.caseAgencyCode,
      clientUuid: data.clientUuid,
      caseUuid: data.caseUuid,
      manager: data.projectManager,
      managerEmail: data.projectManager?.email,
      city: data.rapsoCaseCity || data.caseCity,
      clientName: data.clientLabel,
    };
    return extractedData;
  }
  static async createOrUpdateFromLister(data) {
    const extractedData = await this.formatListerData(data);
    return this._createOrUpdate(extractedData);
  }

  async canBeUpdated() {
    return this?.isStoredOffline || false;
  }

  get caseNumber() {
    if (!this.case) return "";
    return this.case.caseNumber;
  }

  get manager() {
    if (!this.managerEmail) return { firstName: "", lastName: "" };
    const manager = this.managerEmail.split("@")[0];
    let parts = manager.split(".");
    let firstName = parts[0] || "";
    let lastName = parts[1] || "";
    const capitalizeFirstName = firstName
      ? firstName.charAt(0).toUpperCase() + firstName.slice(1)
      : "";
    const capitalizeLastName = lastName
      ? lastName.charAt(0).toUpperCase() + lastName.slice(1)
      : "";
    return {
      firstName: capitalizeFirstName,
      lastName: capitalizeLastName,
    };
  }
}

export default Project;
